const getLaneList = {
  OriginType: '',
  OriginCountryCode: '',
  OriginStateCode: '',
  OriginCities: '',
  OriginPostals: '',
  OriginPortKeys: '',
  OriginName: '',
  DestinationType: '',
  DestinationCountryCode: '',
  DestinationStateCode: '',
  DestinationCities: '',
  DestinationPostals: '',
  DestinationPortKeys: '',
  DestinationName: '',
  pageNo: 1,
  pageSize: 10,
};

export default getLaneList;
